import { dateFormat } from '../models/dateFormat';
var ɵ0 = dateFormat, ɵ1 = { useUtc: true };
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1 };
